import { useEffect, useState } from "react";

// RU-MOBILECARDS MC-1: phone-width layout switch. No matchMedia (old
// browsers, test DOMs) means wide, so the desktop tables render as before.
export const NARROW_QUERY = "(max-width: 640px)";

function query(q) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return null;
  return window.matchMedia(q);
}

export default function useIsNarrow(q = NARROW_QUERY) {
  const [narrow, setNarrow] = useState(() => !!query(q)?.matches);
  useEffect(() => {
    const mql = query(q);
    if (!mql) return undefined;
    const onChange = () => setNarrow(!!mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else if (mql.addListener) mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else if (mql.removeListener) mql.removeListener(onChange);
    };
  }, [q]);
  return narrow;
}
